const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://ldlsettlementservices.com.au/#website",
  "name": "LDL Settlement Services",
  "url": "https://ldlsettlementservices.com.au/",
  "publisher": {
    "@id": "https://ldlsettlementservices.com.au/#business"
  }
};

export default websiteSchema;